const isRequired = (schema) => (id) => {
  return (
    schema
      .describe()
      .fields[id].tests.findIndex(({ name }) => name === 'required') >= 0
  );
};

export default isRequired;
